import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Card } from '@/components/sections/Card';
import { FunctionComponent } from 'react';

interface CustomerCatalogueUserGuideProps {}

const CustomerCatalogueUserGuide: FunctionComponent<CustomerCatalogueUserGuideProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Catalogue User Guide',
      to: ''
    }
  ];

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Catalogue User Guide" breadcrumbs={breadcrumbs} />
      <div className="px-6 py-8 h-full text-lg overflow-y-auto">
        <Card className="p-5 space-y-5">
          <div className="space-y-1">
            <p className="text-xl">
              What is <span className="font-semibold">Basic - Better - Best?</span>
            </p>
            <p>
              These are DaaS Portal's hand chosen devices that we hold in stock. These will meet the needs of the
              majority of customer requirements.
            </p>
            <ul className="list-disc ml-5">
              <li>Available for next day delivery *</li>
              <li>Pre-discounted</li>
              <li>3 year advanced replacement warranty *once your service goes live</li>
            </ul>
            <p className="font-semibold">*once your service goes live</p>
          </div>
          <div className="space-y-1">
            <p className="text-xl font-semibold">Full Catalogue</p>
            <p>This gives you the ability to choose the exact devices you want for your organisation.</p>
            <p>This is dedicated stock for your organization. We refer to this as 'managed inventory'.</p>
            <ul className="list-disc ml-5">
              <li>Available for next day delivery *</li>
              <li>Pre-discounted</li>
              <li>3 year advanced replacement warranty**</li>
            </ul>
            <div>
              <p className="font-semibold">*once your service goes live</p>{' '}
              <p className="font-semibold">**Providing stock is available in your 'managed inventory'</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CustomerCatalogueUserGuide;
